import { generateOtpApi } from 'api/otp';
const UPDATE_STATE = 'firebase/UPDATE_STATE';
const UPDATE_STATE_USER = 'firebase/UPDATE_STATE_USER';
const UPDATE_STATE_OTP_VERIFICATION = 'firebase/UPDATE_STATE_OTP_VERIFICATION';

export const loginSignUpErrorTypes = {
    LOGIN_EMAIL_EXIST: 'LOGIN_EMAIL_EXIST',
    INVALID_EMAIL_DOMAIN: 'INVALID_EMAIL_DOMAIN',
    INVALID_ACTION_CODE: 'INVALID_ACTION_CODE'
};

const defaultState = {
    isLogin: false,
    currentInputEmail: '',
    verifyEmail: '',
    verifyEmailType: '',
    loginSignUpErrorType: '',
    otpVerification: {
        isVerified: false,
        isExpired: false,
        timeStamp: null
    },
    user: {
        name: '',
        email: '',
        avatarSrc: '',
        signInMethods: [],
        signInProvider: ''
    }
};

export default function reducer(state = defaultState, { type, payload }) {
    switch (type) {
        case UPDATE_STATE:
            return { ...state, ...payload };
        case UPDATE_STATE_USER:
            return {
                ...state,
                user: { ...state.user, ...payload.user }
            };
        case UPDATE_STATE_OTP_VERIFICATION:
            return {
                ...state,
                otpVerification: { ...state.otpVerification, ...payload.otpVerification }
            };
        default:
            return state;
    }
}

export function setIsLogin(status) {
    return {
        type: UPDATE_STATE,
        payload: { isLogin: status }
    };
}

export function setVerifyEmailInfo({ verifyEmail = '', verifyEmailType = '' } = {}) {
    return {
        type: UPDATE_STATE,
        payload: { verifyEmail, verifyEmailType }
    };
}

export function setInputEmail(email) {
    return {
        type: UPDATE_STATE,
        payload: { currentInputEmail: email }
    };
}

export function setUserInfo(user = {}) {
    return {
        type: UPDATE_STATE_USER,
        payload: { user }
    };
}

export function setLoginSignUpErrorType(type) {
    return {
        type: UPDATE_STATE,
        payload: { loginSignUpErrorType: type }
    };
}

export function sendOtp() {
    return async (dispatch, getState) => {
        const {
            i18n: { locale }
        } = getState();
        try {
            await generateOtpApi(locale);
            const optExpiredTime = Date.now() + 5 * 60 * 1000;
            dispatch({
                type: UPDATE_STATE_OTP_VERIFICATION,
                payload: { otpVerification: { isExpired: false, timeStamp: optExpiredTime } }
            });
            return { success: 1 };
        } catch (err) {
            if (
                err.httpStatus === 500 &&
                err.payload.message === 'OTP generation failed' &&
                err.payload.data[0].includes('OTP already on going, please try after')
            ) {
                const seconds = err.payload.data[0].match(/(\d+) seconds/)[1];
                const previousOptExpiredTime = Date.now() + seconds * 1000;

                dispatch({
                    type: UPDATE_STATE_OTP_VERIFICATION,
                    payload: {
                        otpVerification: {
                            isExpired: false,
                            timeStamp: previousOptExpiredTime
                        }
                    }
                });
                return { success: 1 };
            }
            return { success: 0, error: err };
        }
    };
}

export function setOtpVerified(isVerified) {
    return {
        type: UPDATE_STATE_OTP_VERIFICATION,
        payload: {
            otpVerification: {
                isVerified,
                ...(isVerified && { timeStamp: null, isExpired: false })
            }
        }
    };
}

export function setOtpExpired() {
    return {
        type: UPDATE_STATE_OTP_VERIFICATION,
        payload: {
            otpVerification: {
                isVerified: false,
                isExpired: true,
                timeStamp: null
            }
        }
    };
}

export function resetOtpState() {
    return {
        type: UPDATE_STATE,
        payload: {
            otpVerification: {
                isVerified: false,
                isExpired: false,
                timeStamp: null
            }
        }
    };
}
